var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLargeCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 51C8.5 27.54 27.54 8.5 51 8.5C74.46 8.5 93.5 27.54 93.5 51C93.5 74.46 74.46 93.5 51 93.5C27.54 93.5 8.5 74.46 8.5 51ZM24.225 53.975L39.4825 69.2325C41.14 70.89 43.86 70.89 45.475 69.2325L77.7325 36.975C79.39 35.3175 79.39 32.64 77.7325 30.9825C76.075 29.325 73.3975 29.325 71.74 30.9825L42.5 60.2225L30.2175 47.9825C28.56 46.325 25.8825 46.325 24.225 47.9825C23.4292 48.7765 22.9819 49.8545 22.9819 50.9787C22.9819 52.1029 23.4292 53.181 24.225 53.975Z",
    fill: "url(#paint0_linear_5503_28244)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5503_28244",
    x1: 93.5,
    y1: 51,
    x2: -3.47764,
    y2: 51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF59A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.288566,
    stopColor: "#D12E7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678745,
    stopColor: "#D12E7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85144A"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLargeCheck);
export default __webpack_public_path__ + "static/media/largeCheck.bcdaaaaf67339f7471f26739a2eb3fe4.svg";
export { ForwardRef as ReactComponent };